import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import {
  ALARM_CENTER_SIDEBAR_PDF_GROUP,
  StatisticsExportSnapshot,
  StatisticsExportWidget,
} from "app/services/statistics-export.models";
import { renderStatCardToPng } from "app/services/statistics-native-canvas.util";

@Component({
  selector: "care-recipient-counter",
  templateUrl: "./care-recipient-counter.component.html",
  styleUrls: ["./care-recipient-counter.component.css"],
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareRecipientCounterComponent implements StatisticsExportWidget {
  constructor(private translate: TranslateService) {}

  @Input() careRecipientCount: number;

  // Only the PDF export uses this now (the PNG download button was removed):
  // it draws the dark-blue counter card with Canvas-2D and embeds the resulting
  // PNG (a raster image, but sharp at 2x) — no html2canvas.
  async captureForExport(): Promise<StatisticsExportSnapshot | null> {
    const imageDataUrl = renderStatCardToPng({
      title: this.translate.instant("CARE_RECIPIENTS"),
      headline: String(this.careRecipientCount ?? 0),
      background: "#07184D",
      foreground: "#ffffff",
    });
    if (!imageDataUrl) {
      return null;
    }
    return {
      slug: "care-recipient-counter",
      titleKey: "CARE_RECIPIENTS",
      imageDataUrl,
      pdfPageGroup: ALARM_CENTER_SIDEBAR_PDF_GROUP,
      omitPdfTitle: true,
    };
  }
}
